import { createClient } from "@sanity/client";

export const client = createClient({
  projectId: "nzs30136",
  dataset: "production",
  apiVersion: "2024-01-01",
  useCdn: false,
});
